// src/components/dashboard/QuickActions.js
import React from 'react';
import { PlusIcon, UserPlusIcon, Cog6ToothIcon } from '@heroicons/react/24/outline';

const QuickActions = () => {
    const actions = [
        { name: 'Create New Promotion', icon: PlusIcon, href: '/promotions/new', color: 'bg-indigo-600 hover:bg-indigo-700' },
        { name: 'View All Customers', icon: UserPlusIcon, href: '/customers', color: 'bg-green-600 hover:bg-green-700' },
        { name: 'Adjust Program Settings', icon: Cog6ToothIcon, href: '/programs/settings', color: 'bg-blue-600 hover:bg-blue-700' },
    ];

    return (
        <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Quick Actions</h3>
            <div className="space-y-4">
                {actions.map((action) => (
                    <a
                        key={action.name}
                        href={action.href}
                        className={`flex items-center justify-center space-x-3 px-4 py-3 rounded-lg text-white font-semibold shadow-sm transition-all duration-200 ${action.color}`}
                    >
                        <action.icon className="h-6 w-6" />
                        <span>{action.name}</span>
                    </a>
                ))}
            </div>
        </div>
    );
};

export default QuickActions;